<template>
	<!-- 关联用户 -->
	<el-dialog :visible.sync="btnAccessshow" title="关联权限按钮" width="42rem" :close-on-click-modal="false" :append-to-body="true" @click="closeDialog()">
		<el-transfer v-model="linkBtn" filterable :data="linkList" :titles="['待选列表', '已选列表']"></el-transfer>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog()">取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title" @click="userPermSave">保存</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { GetUnLinkBtnOpList, GetLinkBtnOpList, SaveBtnOpLink } from "../../../api/menuApi.js";
export default {
	data() {
		return {
			btnAccessshow: false,
			loading: false,
			// 已关联的用户
			linkBtn: [],
			// 关联用户列表
			linkList: []
		};
	},
	computed: {},
	watch: {},

	methods: {
		// 关联权限按钮
		btnAccess(keyId) {
			this.saveroleId = keyId;
			let parmer = {
				keyId: keyId
			};
			let getBtnList = [];
			let checkedUser = [];
			let checkedUserList = [];
			this.linkBtn = [];
			let promise = new Promise((resolve, reject) => {
				GetUnLinkBtnOpList(parmer)
					.then((res) => {
						this.loading = false;
						res.data.forEach((item) => {
							getBtnList.push({
								key: item.keyId,
								label: item.value
							});
						});
						this.linkList = getBtnList;
						resolve();
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("获取权限按钮失败，请稍后再试！");
						resolve();
					});
			});
			promise.then((successMsg) => {
				GetLinkBtnOpList(parmer).then((res) => {
					if (res.code === 1 && res.data.length > 0) {
						this.loading = false;
						res.data.forEach((item) => {
							checkedUserList.push({
								key: item.keyId,
								label: item.value
							});
							checkedUser.push(item.keyId);
						});
						this.linkBtn = checkedUser;
						// this.linkList = this.linkList.concat(checkedUserList);
					}
					this.btnAccessshow = true;
				});
				// .catch((err) => {
				// 	this.loading = false;
				// 	this.linkBtn = [];
				// 	this.$message.error('获取关联权限按钮失败，请稍后再试！');
				// });
			});
		},
		// 保存关联用户
		userPermSave() {
			let parmer = {
				keyId: this.saveroleId,
				keyIds: []
			};
			parmer.keyIds = this.linkBtn;
			SaveBtnOpLink(parmer)
				.then((res) => {
					if (res.code == 1) {
						this.linkBtn = [];
						this.$message({
							type: "success",
							message: "关联权限按钮保存成功"
						});
						this.btnAccessshow = false;
						this.$parent.getListData();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
						this.linkBtn = [];
					}
				})
				.catch((err) => {
					this.$message.error("保存失败，请稍后再试！");
				});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.linkBtn = [];
			this.btnAccessshow = false;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped></style>
